// extracted by mini-css-extract-plugin
export default {"marquee__container":"Marquee_marquee__container__EZ4yk","marquee":"Marquee_marquee__7k98C","marquee__inner":"Marquee_marquee__inner__zpROc"};